import React from 'react'
import { Dialog, DialogContent, DialogActions, Button, Grid, Typography } from '@material-ui/core'
import { useCadastro, useDialog, useGlobalRefresh } from '../context/AppContext'

export default function SuccessDialog(props) {
    const { cadastro, clearCadastro } = useCadastro()
    const { dialog, setDialog } = useDialog()
    
    React.useEffect(() => { }, [dialog])

    const handleOkay = async () => {
        await clearCadastro("Dependente", cadastro.titulo)   
        setDialog(false)
    }

    const handleCancelar = async () => {
        await clearCadastro("Titular", "")
        setDialog(false)
    }

    return(
        <React.Fragment>
            <Dialog
                open={dialog}
            >
                <DialogContent style={{width: "100%", height: "80px", backgroundColor: "white"}}>
                    <Typography align="justify" style={{fontFamily: "Montserrat", fontSize: "14px"}}>
                        Atualização enviada com Sucesso, Deseja Atualizar cadastro
                        { cadastro.dependente === "Titular" ? " de Depentendes?" : " de outro Dependente?"}
                    </Typography>
                </DialogContent>
                <DialogActions style={{width: "100%", height: "60%", backgroundColor: "white"}}>
                    <Grid container justifyContent="flex-end" style={{margin: "10px"}}>
                        <Button variant="outlined" onClick={handleOkay}
                        style={{backgroundColor: "white", color: "black", marginRight: "20px" }}>
                            OK
                        </Button>
                        <Button variant="outlined" onClick={handleCancelar}
                        style={{backgroundColor: "white", color: "black", marginRight: "20px" }}>
                            Cancelar
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}